import { acceptCompanyInviteAction } from "./api/acceptCompanyInviteAction";

export const UserAcceptCompanyInviteComponent = {
  data() {
    return {
      isLoading: false,
      isSuccess: false,
    };
  },
  methods: {
    async acceptCompanyInvite() {
      try {
        this.isLoading = true;
        const { width, height } =
          this.$refs.acceptButton.getBoundingClientRect();

        this.$refs.acceptButton.style.width = width + "px";
        this.$refs.acceptButton.style.height = height + "px";
        const response = await acceptCompanyInviteAction();

        this.isLoading = false;
        this.$refs.acceptButton.removeAttribute("style");

        toastr[response.data.status](response.data.message, "", {
          timeOut: 5000,
          progressBar: false,
          newestOnTop: true,
        });

        if (response.data.status === "success") {
          document
            .querySelectorAll(".main-page-materials")
            .forEach((pageMaterial) => {
              pageMaterial.classList.replace("col-xl-4", "col-xl-6");
            });

          this.isSuccess = true;
        }
      } catch (error) {
        this.isLoading = false;
        toastr["error"](error, "", {
          timeOut: 5000,
          progressBar: false,
          newestOnTop: true,
        });
      }
    },
  },
  template: `
		<div class="card" v-if="!isSuccess">
			<div class="card-header">
				<div class="row">
					<div class="col">
						<h4 class="mb-0">{{$Bitrix.Loc.getMessage('PERSONAL_COMPANY_INVITE_WIDGET_TITLE')}}</h4>
					</div>
				</div>
			</div>
			<div class="card-body position-relative">
				<p v-html="$store.state.params.inviteText"></p>
				<div class="d-flex">
					<button class="btn btn-primary ms-auto" :disabled="isLoading" ref="acceptButton" @click="acceptCompanyInvite">
						<template v-if="!isLoading">
							{{$Bitrix.Loc.getMessage('PERSONAL_COMPANY_INVITE_WIDGET_ACCEPT_BUTTON')}}
						</template>
						<div v-else class="spinner-border spinner-border-tiny"></div>
					</button>
				</div>
			</div>
    </div>
	`,
};
